<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Anna, Banana, and the Puppy Parade, by Anica Mrose Rissi, illustrated by Meg Park." class="imagefp" src="images/9781481416160.jpg"/></div>
<div class="ipadfp"><a id="title"></a><a id="page_iii"><img alt="Images" class="imagefp" src="images/title.jpg"/></a></div><a id="page_iii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?07586aaf